import React from 'react';
import { PriceSeriesChart } from './charts/SalesChartPrimitives';
import { SalesDisclosure, SalesState } from './SalesDossierShared';
import { salesPrice, salesPercent, salesMonth } from '../utils/salesMetrics';

function MarginCards({ cards }) {
  if (!cards) return null;
  const empty = reason => reason === 'nonpositive_selling'
    ? 'No positive sales in the period' : reason === 'not_enough_history'
    ? 'Not enough history' : 'Not enough data';
  const { margin, trend, gap } = cards;
  return <div className="matd-sales-stats" data-margin-cards>
    <div><span>Margin</span>{margin.status === 'available'
      ? <><strong>{salesPercent(margin.margin_pct)}</strong><span>{salesMonth(margin.month)}</span></>
      : <strong className="sales-empty">{empty(margin.reason)}</strong>}</div>
    <div><span>Margin trend</span>{trend.status === 'available'
      ? <><strong>{salesPercent(trend.from_pct)} → {salesPercent(trend.to_pct)}</strong><span>{salesMonth(trend.from_month)} → {salesMonth(trend.to_month)}</span></>
      : <strong className="sales-empty">{empty(trend.reason)}</strong>}</div>
    <div><span>Cost basis vs purchase price</span>{gap.status === 'available'
      ? <><strong>{salesPrice(gap.unit_gap)} / unit{gap.purchase_pct != null && <> · purchase is {salesPercent(gap.purchase_pct)} of selling price, cost gap adds {salesPercent(gap.gap_pct)}</>}</strong>
          <span>{salesMonth(gap.month)} · difference between your ERP cost and the average purchase price · basis unconfirmed</span></>
      : <strong className="sales-empty">{empty(gap.reason)}</strong>}</div>
  </div>;
}

export default function MaterialPriceOverview({ request }) {
  const data = request.data, prices = data?.average_price_series;
  return <section className="matd-sales ui-card" aria-label="Average prices"><h2>Average purchase, cost, and selling price</h2>
    {!data || request.error ? <SalesState request={request}/> : <><PriceSeriesChart data={prices} label="Average purchase, cost, and selling price"/>
      <MarginCards cards={data.margin_cards} />
      {prices?.note && <p className="sales-data-note">{prices.note}</p>}
      <SalesDisclosure basis={data.basis || {}} purchaseCoverage={{start:prices?.purchase_start,end:prices?.purchase_end}} headline />
    </>}
  </section>;
}
